import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';

import "./index.scoped.css";
import { AppStore } from "@/store/";
import version from "@/assets/version.json";



@inject(stores => ({
    appStore: stores.appStore,
}))
@observer
class About extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dev: 0,
            version,
        };
    }

    enterDev = () => {
        this.setState({
            dev: this.state.dev + 1,
        }, () => {
            if (this.state.dev == 5) {
                this.props.appStore.toggleDevMode({ on_off: true });
                window.mdui.snackbar({
                    message: 'DevMode is Open',
                });
            }
        });
    }

    clearCache = () => {
        localStorage.clear();
        location.reload(true);
    }
    render() {
        return (
            <div id="about">
                <div className="top">
                    <div className="mdui-card">
                        <div className="mdui-card-media">
                            <img src={require("./about.gif")} onClick={() => { return false; }} />
                            <div className="mdui-card-media-covered mdui-card-media-covered-gradient">
                                <div className="mdui-card-primary">
                                    <div className="mdui-card-primary-title">About</div>
                                    <div className="mdui-card-primary-subtitle">Parking</div>
                                </div>
                            </div>
                        </div>
                        <div className="mdui-card-actions">
                            <ul className="mdui-list mdui-list-dense">
                                <li className="mdui-list-item mdui-ripple">
                                    <i className="mdui-list-item-icon mdui-icon material-icons">send</i>
                                    <div className="mdui-list-item-content"> <a href="mailto:liuqinzhi@live.cn">liuqinzhi@live.cn</a> </div>
                                </li>
                                <li className="mdui-list-item mdui-ripple">
                                    <i className="mdui-list-item-icon mdui-icon material-icons">merge_type</i>
                                    <div className="mdui-list-item-content">只差一个设计系列</div>
                                </li>
                                <li className="mdui-subheader-inset mdui-ripple">
                                    <span className="ver" onClick={this.enterDev}>Ver 1.1</span>
                                    <span className="copyRight">Powered by <span className="love">♥</span></span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="thanks">
                        <p className="title">鸣谢</p>
                        <p>株洲停车官网提供数据支持</p>
                        <p>llx 同学提供 icon svg</p>
                        <p>{JSON.stringify(this.state.version)}</p>
                        <button className="mdui-btn mdui-btn-raised mdui-ripple mdui-color-theme-accent mdui-btn-dense" onClick={() => this.clearCache()}>清除缓存</button>
                    </div>
                </div>
            </div >
        );
    }
}

About.wrappedComponent.propTypes = {
    appStore: PropTypes.instanceOf(AppStore).isRequired,
};

export default About;